import { render, staticRenderFns } from "./StopList.vue?vue&type=template&id=2b355022&scoped=true&"
import script from "./StopList.vue?vue&type=script&lang=js&"
export * from "./StopList.vue?vue&type=script&lang=js&"
import style0 from "./StopList.vue?vue&type=style&index=0&id=2b355022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b355022",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b355022')) {
      api.createRecord('2b355022', component.options)
    } else {
      api.reload('2b355022', component.options)
    }
    module.hot.accept("./StopList.vue?vue&type=template&id=2b355022&scoped=true&", function () {
      api.rerender('2b355022', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Stops/StopList.vue"
export default component.exports